export default __webpack_public_path__ + "static/media/ILP.4d7cb61f.png";